import { IFuncUpdater } from 'ahooks/lib/createUseStorageState'
import moment from 'moment'

import { CreatePostLinkInput, PostType } from '@/generated/graphql'

export const emptyPostEditorState = {
  content: '',
  files: [],
  links: {},
  isMarkdown: true,
  isAnonymous: false,
  postType: PostType.General,
}
export const emptyEventState = {
  topic: '',
  content: '',
  location: '',
  openPosition: null,
  guests: [],
  avcRoom: '',
  avcPassword: '',
  avcLink: '',
}

export const emptyHonorState = {
  title: '',
  commendation: '',
  honoredProjects: '',
  honoredIndividuals: [],
  honoredSignificants: [],
}

export interface PostEditorState {
  content: string
  files: any[]
  links: {
    [url: string]: CreatePostLinkInput
  }
  isMarkdown: boolean
  isAnonymous: boolean
  postType: PostType
}

export const journalTemplate = (projects: string[]) => {
  const format = 'YYYY.MM.DD'
  const startDayOfWeek = moment().startOf('week').format(format)
  const endDayOfWeek = moment().endOf('week').format(format)
  return `## 【周记】${startDayOfWeek} - ${endDayOfWeek}
#### 本周工作内容
${projects.length !== 0 ? projects.reduce((acc, curr) => acc + `##### ${curr}\n-\n`, '') : ''}

#### 下周工作计划
${projects.length !== 0 ? projects.reduce((acc, curr) => acc + `##### ${curr}\n-\n`, '') : ''}

#### 临时任务

#### 思考与分享`
}

export type PostEditorSetState = (value: PostEditorState | IFuncUpdater<PostEditorState>) => void
